import React from 'react'
import ReactDOM from 'react-dom'
import CaesarCipherPage from "./components/CaesarCipher/CaesarCipherPage";
import Home from "./components/Home";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MultiplicativeCipherPage from "./components/MultiplicativeCipher/MultiplicativeCipherPage";
import PlayfairCipherPage from "./components/PlayfairCipher/PlayfairCipherPage";
import VigenereCipherPage from "./components/VigenereCipher/VigenereCipherPage";
import KeylessCipherPage from "./components/KeylessCipher/KeylessCipherPage";
import VernamCipherPage from "./components/VernamCipher/VernamCipherPage";
import KeyedCipherPage from "./components/KeyedCipher/KeyedCipherPage";
import SplashScreen from './components/SplashScreen';

function App() {
  return (
    <>
      {/* This is the alias of BrowserRouter i.e. Router */}
      <Router>
        <Routes>
          
          <Route
            exact
            path="/"
            element={<SplashScreen />}
          />

          <Route
            path="/Home"
            element={<Home />}
          />

          <Route
            path="/caesarcipher"
            element={<CaesarCipherPage />}
          />

          <Route
            path="/multiplicativecipher"
            element={<MultiplicativeCipherPage />}
          />

          <Route
            path="/playfaircipher"
            element={<PlayfairCipherPage />}
          />

          <Route
            path="/vigenerecipher"
            element={<VigenereCipherPage />}
          />
          
          <Route
            path="/keylesstransposition"
            element={<KeylessCipherPage />}
          />
          
          <Route
            path="/vernamcipher"
            element={<VernamCipherPage />}

          />

          <Route
            path="/keyedtransposition"
            element={<KeyedCipherPage />}
          />
          {/* If any route mismatches the upper 
          route endpoints then, redirect triggers 
          and redirects app to home component with to="/" */}
          <Route
            path="*"
            element={<Navigate to="/" />}
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
